import axios from "axios";
import { SET_ERROR, INVENTORY_ITEMS, ADD_INVENTORY_ITEMS } from "../../types"

export const addInventoryItems = payload => {
    return async dispatch => {
        await axios.post('/api/inventory-items/add-items', payload).then(res => {
            dispatch({
                type: ADD_INVENTORY_ITEMS,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const inventoryItemsBySerial = serials => {
    return async dispatch => {
        await axios.get(`/api/inventory-items/by-serial?${serials}`).then(res => {
            dispatch({
                type: INVENTORY_ITEMS,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const getAllInventoryItems = () => {
    return async dispatch => {
        await axios.get('/api/inventory-items/all-items').then(res => {
            dispatch({
                type: INVENTORY_ITEMS,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};

export const updateMultipleItems = (fieldName, filter, payload) => {
    return async dispatch => {
        await axios.post('/api/inventory-items/update-multiple-items', { fieldName, filter, payload }).then(res => {
            dispatch({
                type: INVENTORY_ITEMS,
                payload: res.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: { e, error: true }
            });
        });
    };
};